import { bindable } from 'aurelia';

export class UndrawComponent {
  @bindable message: string = 'Nenhum dado encontrado';
  @bindable image: string = 'assets/images/undraw.svg';
}